/**
 * Supported reported action types.
 *
 * @type {Object<String>}
 */
export const ACTION_TYPES = {
    IMPRESSION: 'imp',
    CLICK: 'click',
    HOVER: 'hover',
};
